import { topicItems } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">热门话题</h2>
          <p className="mt-2 text-sm text-foreground-500">大家都在讨论的内容</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4">
          {topicItems.map((item) => (
            <a
              key={item.id}
              href="#cards"
              className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full ${item.color} text-sm font-medium transition-all duration-200 hover:scale-105 cursor-pointer whitespace-nowrap`}
            >
              <span>{item.name}</span>
              <span className="text-[11px] opacity-70">{item.heat}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}